import { PlannerProductComponent, ShoppingBagComponent, DoorOpeningDirectionComponent, ProductType, getProductReferenceFor, isOfType, isUnavailableProduct, isProductPart, UnavailableProductComponent, InteriorComponent, OuterMeasurementsComponent, getProduct, FrontLayoutComponent, HideFromAssemblyInstructionsComponent, TopPanelComponent, RangeComponent, TVComponent, SuspensionRailComponent, OrganizerComponent, HideFromVpcImagesComponent, HideInSeeThroughSystemComponent, NonBehaviorDeleteComponent, AssemblyInstructionsComponent, DistanceMeasurementComponent, NonDuplicatableComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, SelectableComponent } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import BestaOpeningFunctionComponent from '../components/BestaOpeningFunctionComponent';
import BestaFrameComponent from '../components/BestaFrameComponent';
import NotSupportLeg from '../components/NotSupportLeg';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
const getValidDrawers = (entity, products) => {
    const productRef = getProductReferenceFor(entity);
    const frame = products.find(p => p.coreProductId === productRef);
    const validDrawers = products.filter(p => p.type === ProductType.BESTA_DRAWER_FRAME && p.design === frame?.design);
    return {
        low: validDrawers?.find(d => d.dimensions.height === 150)?.coreProductId,
        high: validDrawers?.find(d => d.dimensions.height === 250)?.coreProductId
    };
};
export const bestaComponentResolver = (coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts) => {
    // Should include all product types that should be added to the price/shoppinglist
    const isShoppingProduct = isOfType([
        ProductType.BESTA_FRAME,
        ProductType.BESTA_TV_BENCH,
        ProductType.BESTA_SHELF,
        ProductType.BESTA_GLASS_SHELF,
        ProductType.BESTA_BOTTLE_RACK,
        ProductType.BESTA_LEG,
        ProductType.BESTA_SUPPORTING_LEG,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.BESTA_DRAWER_FRAME,
        ProductType.BESTA_DRAWER_FRONT,
        ProductType.BESTA_DOOR_DRAWER_FRONT,
        ProductType.BESTA_PUSH_OPEN,
        ProductType.BESTA_SOFT_CLOSING,
        ProductType.BESTA_HINGE_DOOR_SOFT_CLOSING,
        ProductType.BESTA_HINGE,
        ProductType.BESTA_TOP_PANEL,
        ProductType.BESTA_TOP_PANEL_TV_BENCH,
        ProductType.BESTA_FRAME_SUSPENSION_RAIL,
        ProductType.BESTA_INNER_LIGHT,
        ProductType.LIGHT_CONTROLER,
        ProductType.LIGHT_CORD,
        ProductType.LIGHT_DRIVER,
        ProductType.BESTA_SHELF_ORGANIZER,
        ProductType.BESTA_DRAWER_ORGANIZER,
        ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.BESTA_FRAME_600_ASM,
        ProductType.BESTA_FRAME_1200_ASM,
        ProductType.BESTA_TV_BENCH_1200_ASM,
        ProductType.BESTA_TV_BENCH_1800_ASM,
        ProductType.BESTA_SHELF,
        ProductType.BESTA_GLASS_SHELF,
        ProductType.BESTA_BOTTLE_RACK,
        ProductType.BESTA_LEG,
        ProductType.BESTA_SUPPORTING_LEG,
        ProductType.BESTA_DEFAULT_LEG,
        ProductType.HANDLE,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.BESTA_DOOR_64_ASM,
        ProductType.BESTA_DOOR_38_ASM,
        ProductType.BESTA_DOOR_192_ASM,
        ProductType.BESTA_DRAWER_26_ASM,
        ProductType.BESTA_DRAWER_38_ASM,
        ProductType.BESTA_TOP_PANEL,
        ProductType.BESTA_TOP_PANEL_TV_BENCH,
        ProductType.BESTA_FRAME_SUSPENSION_RAIL,
        ProductType.BESTA_INNER_LIGHT,
        ProductType.TV,
        ProductType.TV_WITH_FOOT,
        ProductType.BESTA_SHELF_ORGANIZER,
        ProductType.BESTA_DRAWER_ORGANIZER,
        ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER
    ]);
    const hideInSeeThroughEntitySystem = isOfType([
        ProductType.TV,
        ProductType.BESTA_FRAME_600_ASM,
        ProductType.BESTA_FRAME_1200_ASM,
        ProductType.BESTA_TV_BENCH_1200_ASM,
        ProductType.BESTA_TV_BENCH_1800_ASM
    ]);
    const isDrawerAssembly = isOfType([
        ProductType.BESTA_DRAWER_26_ASM,
        ProductType.BESTA_DRAWER_38_ASM
    ]);
    const isFrameAssembly = isOfType([
        ProductType.BESTA_FRAME_600_ASM,
        ProductType.BESTA_FRAME_1200_ASM
    ]);
    const isFrame = isOfType([ProductType.BESTA_FRAME, ProductType.BESTA_TV_BENCH]);
    const isTVBenchAssembly = isOfType([
        ProductType.BESTA_TV_BENCH_1200_ASM,
        ProductType.BESTA_TV_BENCH_1800_ASM
    ]);
    const shouldBeRemovedFromAssemblyImages = isOfType([
        ProductType.BESTA_DRAWER_FRONT,
        ProductType.BESTA_DOOR_64_ASM,
        ProductType.BESTA_DOOR_38_ASM,
        ProductType.BESTA_DOOR_192_ASM,
        ProductType.BESTA_DOOR_DRAWER_FRONT,
        ProductType.TV,
        ProductType.TV_WITH_FOOT
    ]);
    // Doors are hidden in screenshot functions because some VPC images
    // shall show doors and others not
    const shouldBeRemovedFromVpcImages = isOfType([ProductType.TV, ProductType.TV_WITH_FOOT]);
    const isTopPanel = isOfType([ProductType.BESTA_TOP_PANEL, ProductType.BESTA_TOP_PANEL_TV_BENCH]);
    const isInterior = isOfType([
        ProductType.BESTA_SHELF,
        ProductType.BESTA_GLASS_SHELF,
        ProductType.BESTA_BOTTLE_RACK
    ]);
    const isDoor = isOfType([
        ProductType.BESTA_DOOR_38_ASM,
        ProductType.BESTA_DOOR_64_ASM,
        ProductType.BESTA_DOOR_192_ASM
    ]);
    const isDefaultLeg = isOfType([ProductType.BESTA_DEFAULT_LEG]);
    const isLeg = isOfType([ProductType.BESTA_LEG]);
    const isFront = isOfType([
        ProductType.BESTA_DRAWER_FRONT,
        ProductType.BESTA_DOOR_DRAWER_FRONT,
        ProductType.BESTA_HINGE_DOOR_SOFT_CLOSING
    ]);
    const isTV = isOfType([ProductType.TV, ProductType.TV_WITH_FOOT]);
    const isOrganizer = isOfType([
        ProductType.BESTA_SHELF_ORGANIZER,
        ProductType.BESTA_DRAWER_ORGANIZER,
        ProductType.BESTA_SHELF_AND_DRAWER_ORGANIZER
    ]);
    const isNonDuplicatable = isOfType([
        ProductType.TV,
        ProductType.TV_WITH_FOOT,
        ProductType.BESTA_LEG
    ]);
    const getDrawerOpeningFunction = (entity, products) => {
        const runnerEntity = entity.getComponent(ComponentIds.PARENT_COMPONENT_ID)
            ?.children[0];
        const productRef = runnerEntity?.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)?.productRef;
        const runnerProduct = products.find(p => p.coreProductId === productRef);
        if (runnerEntity && runnerProduct && runnerProduct.type === ProductType.BESTA_SOFT_CLOSING) {
            return ProductType.BESTA_SOFT_CLOSING;
        }
        return ProductType.BESTA_PUSH_OPEN;
    };
    const shouldNotBeSelectable = (entity) => {
        return coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.HANDLE,
            ProductType.EDGE_HANDLE,
            ProductType.KNOB
        ]);
    };
    const shouldNotBeDraggable = (entity) => {
        return isDoor(entity) || isDrawerAssembly(entity);
    };
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (isUnavailableProduct(entity, unavailableProducts) &&
                (!isProductPart(entity) || isLeg(entity))) {
                entity.addComponent(new UnavailableProductComponent());
                entity.addComponent(new OutlinedComponent());
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (isLeg(entity)) {
                entity.addComponent(new SelectableComponent());
                const productsThatCannotBeUsedAsSupportLegs = [
                    'ART-10293597',
                    'ART-50293595',
                    'ART-20293592'
                ]; // NANNARP leg
                if (productsThatCannotBeUsedAsSupportLegs.includes(product?.globalItemNo)) {
                    entity.addComponent(new NotSupportLeg());
                }
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
                entity.addComponent(new RangeComponent('besta'));
            }
            if (shouldNotBeSelectable(entity)) {
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (shouldNotBeDraggable(entity)) {
                entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
                entity.addComponent(new RangeComponent('besta'));
            }
            if (isFrame(entity) ||
                isTopPanel(entity) ||
                isLeg(entity) ||
                isDefaultLeg(entity) ||
                isFront(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (product && (isFrameAssembly(entity) || isTVBenchAssembly(entity))) {
                entity.addComponent(new FrontLayoutComponent(product.meta?.defaultFrontLayout || ''));
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
            if (shouldBeRemovedFromVpcImages(entity)) {
                entity.addComponent(new HideFromVpcImagesComponent());
            }
            if (isFrameAssembly(entity) || isTVBenchAssembly(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
            }
            else if (isFrameAssembly(entity)) {
                entity.addComponent(new BestaFrameComponent(getValidDrawers(entity, products)));
                if (entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.width === 1200) {
                    entity.addComponent(new SuspensionRailComponent(2));
                }
                entity.addComponent(new DoorOpeningDirectionComponent());
            }
            else if (isTVBenchAssembly(entity)) {
                entity.addComponent(new BestaFrameComponent(getValidDrawers(entity, products)));
                entity.addComponent(new DoorOpeningDirectionComponent());
            }
            else if (isDrawerAssembly(entity)) {
                const openingFunction = getDrawerOpeningFunction(entity, products);
                entity.addComponent(new BestaOpeningFunctionComponent(openingFunction));
            }
            if (isDoor(entity)) {
                entity.addComponent(new BestaOpeningFunctionComponent(ProductType.BESTA_PUSH_OPEN));
            }
            if (isTopPanel(entity)) {
                entity.addComponent(new TopPanelComponent());
            }
            if (isTV(entity)) {
                entity.addComponent(new TVComponent());
                entity.addComponent(new NonBehaviorDeleteComponent());
            }
            if (isOrganizer(entity)) {
                entity.addComponent(new OrganizerComponent());
            }
            if (isNonDuplicatable(entity)) {
                entity.addComponent(new NonDuplicatableComponent());
            }
        }
    };
    return {
        info: {
            organization: 'com.ikea.range.besta',
            name: 'besta-component-builder-resolver',
            version: '0.1',
            description: 'Resolves besta component builders for different product types',
            type: 'ComponentResolver'
        },
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=bestaComponentResolver.js.map